// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.fastex.wallet",
    name: "Fastex Wallet",
    homepage: "https://fastexwallet.com",
    image_id: "a38db32b-8291-4d25-9aae-4bf4b6e6f300",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/fastex-wallet/id6474118944",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.fastex.wallet",
    mobile: {
        native: "fastex-wallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map